import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { UserImageService } from 'shared/core/services/user/user-image.service';

@Pipe({ name: 'userImage', standalone: true })
export class UserImagePipe implements PipeTransform {
    private svc = inject(UserImageService);
    transform(name?: string | null): Observable<string> {
        return this.svc.get(name);
    }
}